import { Cookies } from "react-cookie";

type HTTPMethod = 'GET'|'POST'|'PUT'|'PATCH'|'DELETE';

export default class AbstractApiService {

    call = (method: HTTPMethod, path: string, data?: BodyInit, headers?: HeadersInit): Promise<any> => {
        return new Promise((resolve, reject) => {
            const cookies = new Cookies();

            const init: RequestInit = {
                method: method,
                headers: {
                    'Accept': 'application/json',
                    'X-XSRF-TOKEN': cookies.get('XSRF-TOKEN') || '',
                },
                credentials: 'include',
            };

            if(typeof data === 'string') {
                init.headers = {...init.headers, 'Content-Type': 'application/json'};
            }

            init.headers = {
                ...init.headers,
                ...headers,
            };

            if(method !== 'GET') {
                init.body = data;
            }
            
            fetch(process.env.REACT_APP_API_URL + path, init).then(resp => {
                if(resp.status === 200 || resp.status === 201) {
                    resp.json().then(dataResp => resolve({status: resp.status, body: dataResp})).catch(reject);
                }
                else if(resp.status === 204) {
                    resolve({status: 204, data: {}});
                }
                else {
                    resp.json().then(dataResp => reject({status: resp.status, body: dataResp})).catch(reject);
                }
            }).catch(reject);
        });
    };
}
